import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';

@Component({
    selector: 'app-webview-section',
    templateUrl: './webview-section.component.html',
    styleUrls: ['./webview-section.component.scss']
})
export class WebviewSectionComponent implements OnInit, OnChanges {
    @Input() url: string = '';
    
    constructor() {}

    ngOnInit(): void {
        window.open(this.url, '_blank');
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes['url']) {
            window.open(this.url, '_blank');
        }
    }
}
